import { render, staticRenderFns } from "./deposit_refund_detail_dialog.vue?vue&type=template&id=573ad9b7"
import script from "./deposit_refund_detail_dialog.vue?vue&type=script&lang=js"
export * from "./deposit_refund_detail_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports